import {
  queryOptions,
  useMutation,
  type UseMutationOptions,
} from "@tanstack/react-query";
import { queryClient } from "@config/tanstack/tanstackQuery";
import { backendApi } from "../backendApi";
//
import type {
  SpringHealthEligiblePayload,
  SpringHealthEligibileResp,
  //
  SpringHealthEnrollPayload,
  SpringHealthEnrollResp,
} from "@neuromotion-inc/mightier-ts-sdk";

export const springHealthEligibileQueryOpts = (
  payload: SpringHealthEligiblePayload,
) => {
  return queryOptions({
    queryKey: ["spring-health", "eligibility", payload],
    queryFn: async () => {
      console.log("RUNNING ");
      const resp = await backendApi.springHealthCheckEligibility(payload);
      return resp.data;
    },
  });
};

//
//
//

interface CheckSpringEligibilityMutationVars {
  payload: SpringHealthEligiblePayload;
}

type CheckSpringEligibilityMutOpts = Pick<
  UseMutationOptions<
    SpringHealthEligibileResp,
    Error,
    CheckSpringEligibilityMutationVars
  >,
  "onError" | "onSuccess"
>;

export const useCheckSpringEligibilityMutation = (
  opts: CheckSpringEligibilityMutOpts,
) => {
  return useMutation({
    ...opts,
    mutationFn: async (vars: CheckSpringEligibilityMutationVars) => {
      const resp = await backendApi.springHealthCheckEligibility(vars.payload);
      return resp.data;
    },
    onSuccess: (data, vars, ...rest) => {
      const queryKey = springHealthEligibileQueryOpts(vars.payload).queryKey;
      queryClient.setQueryData(queryKey, data);
      opts.onSuccess?.(data, vars, ...rest);
    },
  });
};

//
//
//

interface SpringEnrollMutationVars {
  payload: SpringHealthEnrollPayload;
}

type SpringEnrollMutationOpts = Pick<
  UseMutationOptions<SpringHealthEnrollResp, Error, SpringEnrollMutationVars>,
  "onError" | "onSuccess"
>;

export const useSpringEnrollMutation = (opts: SpringEnrollMutationOpts) => {
  return useMutation({
    ...opts,
    mutationFn: async (vars: SpringEnrollMutationVars) => {
      const resp = await backendApi.springHealthEnroll(vars.payload);
      return resp.data;
    },
  });
};
